import moment from 'moment';
import { put, select } from 'redux-saga/effects';
import { change } from 'redux-form';
import {
  IS_FLIGHT_TIME_FIELD_NAME,
  IS_RETURN_FLIGHT_TIME_FIELD_NAME
} from 'app/constants';
import formConfig from 'app/forms/search-form';
import { getSearchForm } from 'app/sagas/selectors';
import { outdateSearch } from 'app/actions/search-results';
import config from 'config';

const legs = [
  { flagField: IS_FLIGHT_TIME_FIELD_NAME, pickupField: 'pickup_datetime', stepsKey: 'steps' },
  { flagField: IS_RETURN_FLIGHT_TIME_FIELD_NAME, pickupField: 'return_pickup_datetime', stepsKey: 'returnSteps' },
];

// Form dates are local moments holding the wall-clock time, like the ones parsed from the URL.
const toWallClock = (datetime) => moment(datetime.format('YYYY-MM-DDTHH:mm:ss'));

export default function* showPlannedPickup(trip) {
  if (!config.SHOW_FLIGHT_TIME_FOR_AIRPORTS || !trip) return;

  const searchForm = yield select(getSearchForm);
  if (!searchForm) return;

  // Runs inside the search polling loop: a failure here must not end the search.
  try {
    let somethingChanged = false;
    for (const { flagField, pickupField, stepsKey } of legs) {
      const departure = trip[stepsKey]?.find((step) => step.main)?.departureDatetime;
      if (searchForm[flagField] && departure?.isValid()) {
        yield put(change(formConfig.form, flagField, false));
        yield put(change(formConfig.form, pickupField, toWallClock(departure)));
        somethingChanged = true;
      }
    }

    if (somethingChanged) {
      yield put(outdateSearch(false));
    }
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
  }
}
